import { FC } from "react";
import { cn } from "../utils/class-names";

export const LlamaIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={cn("w-6 h-6", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="720"
    height="720"
    viewBox="0 0 720 720"
  >
    <path
      fill="#FCFCFC"
      d="m329 78 4 2c9 4 16 9 23 17l3 2 7 10 1 2 7 13 1 2 5 15h2c4 1 6 3 8 6 2 4 2 7 2 11l2 1c5 2 7 5 9 9 1 5 0 9-1 13l1 9-2 18-1 9c-1 7-4 12-10 17l-5 5c-4 5-3 13-3 19v3a4262 4262 0 0 0-2 64c-2 27-2 27 4 53v2c5 3 10 2 15 2a540907697 540907697 0 0 0 78 1c24 0 44 2 62 20l9 11 2 3 5 10 3 7c8 17 8 37 8 56v2c0 31-4 60-20 87-3 5-4 8-4 14v6a40387 40387 0 0 1-1 28v3c-1 11-1 24-10 33-7 6-14 6-23 6h-3a1156 1156 0 0 1-21 1h-3c-8 0-14-3-20-8-6-8-7-18-8-28v-3a1710 1710 0 0 1-2-24c1-10 1-10-2-18h-13a4698 4698 0 0 0-35 0h-55a374 374 0 0 0-1 38c-1 29-1 29-9 37-7 5-13 5-22 5h-3a891 891 0 0 1-21 0h-3c-7 0-13-1-19-5-9-10-9-24-10-37a8574 8574 0 0 0-2-33c0-6 0-6-3-11l-3-2-2-2-2-1c-19-15-27-38-30-61-2-14-1-28 0-42a35067 35067 0 0 0 13-172l3-35-4-1c-10-4-20-8-25-18-3-6 0-14 1-20l3-1c1-10-4-17-8-25-9-15-11-32-7-49l5-15-2-1c-3-1-4-3-5-6 1-3 1-5 3-7l10-4c4-1 4-3 6-6a89 89 0 0 1 55-41l4-2c20-6 42-2 61 6Z"
    />
    <path
      fill="#070707"
      d="m329 78 4 2c9 4 16 9 23 17l3 2 7 10 1 2 7 13 1 2 5 15h2c4 1 6 3 8 6 2 4 2 7 2 11l2 1c5 2 7 5 9 9 1 5 0 9-1 13l1 9-2 18-1 9c-1 7-4 12-10 17l-5 5c-4 5-3 13-3 19v3a4262 4262 0 0 0-2 64c-2 27-2 27 4 53v2c5 3 10 2 15 2a540907697 540907697 0 0 0 78 1c24 0 44 2 62 20l9 11 2 3 5 10 3 7c8 17 8 37 8 56v2c0 31-4 60-20 87-3 5-4 8-4 14v6a40387 40387 0 0 1-1 28v3c-1 11-1 24-10 33-7 6-14 6-23 6h-3a1156 1156 0 0 1-21 1h-3c-8 0-14-3-20-8-6-8-7-18-8-28v-3a1710 1710 0 0 1-2-24c1-10 1-10-2-18h-13a4698 4698 0 0 0-35 0h-55a374 374 0 0 0-1 38c-1 29-1 29-9 37-7 5-13 5-22 5h-3a891 891 0 0 1-21 0h-3c-7 0-13-1-19-5-9-10-9-24-10-37a8574 8574 0 0 0-2-33c0-6 0-6-3-11l-3-2-2-2-2-1c-19-15-27-38-30-61-2-14-1-28 0-42a35067 35067 0 0 0 13-172l3-35-4-1c-10-4-20-8-25-18-3-6 0-14 1-20l3-1c1-10-4-17-8-25-9-15-11-32-7-49l5-15-2-1c-3-1-4-3-5-6 1-3 1-5 3-7l10-4c4-1 4-3 6-6a89 89 0 0 1 55-41l4-2c20-6 42-2 61 6Zm42 168c-7 5-15 9-24 12h-2a1034 1034 0 0 1-12 4c-32 11-66 13-99 6l-3 29v2a5664 5664 0 0 0-1 16l-1 4v7l-2 12v2a4033 4033 0 0 0-6 93l-1 2a2366 2366 0 0 0 0 9c-5 51-5 51 4 99l1 2a81 81 0 0 0 24 33c9 8 19 11 32 11h2l11-1 3 38c0 18 0 18 6 35v3l-1-2h-2l-3-9-1-3-1-12a23780 23780 0 0 0 0-14c0-17 0-17-5-33h-14c-6-1-10-1-15-4h-3l1 31 2 20v5l1 8h2v2l4 8 2 2c5 5 12 4 19 4h3a1275 1275 0 0 0 22 1h3c7 0 11-2 17-6l2-1c2-2 4-3 5-7v-14a2462 2462 0 0 0 1-17v-3l1-19v-2l1-11a45991 45991 0 0 1 96 0h3l14 1a132 132 0 0 0 9 0h7l16-1v15l1 13a4993 4993 0 0 0 1 15c0 16 0 16 6 31l1 3 4 3h10c7 0 12-3 18-7 3-4 5-8 5-13h2l1-12v-7a10709 10709 0 0 1 1-30v-4c0-7 1-11 5-17l1-3 5-8c9-15 11-30 13-47v-2l1-25v-8c0-14 0-29-5-43h-2v-2c-1-4-2-7-5-11-3-3-3-5-4-9-3-11-13-18-21-24l-2-2c-16-10-32-10-50-10a4231 4231 0 0 1-26 0h-30a3853 3853 0 0 0-21 0h-9l-5-1-2-4-2-3c-2-5-2-10-2-16v-11a2042 2042 0 0 1 1-106c-4 0-5 1-8 3Z"
    />
    <path
      fill="#0D0D0D"
      d="m329 78 4 2c9 4 16 9 23 17l3 2 7 10 1 2 7 13 1 2 5 15h2c4 1 6 3 8 6 2 4 2 7 2 11l2 1c5 2 7 5 9 9 1 5 0 9-1 13l1 9-2 18-1 9c-1 7-4 12-10 17l-5 5c-4 5-3 13-3 19v3a4262 4262 0 0 0-2 64c-2 27-2 27 4 53v2c5 3 10 2 15 2a540907697 540907697 0 0 0 78 1c24 0 44 2 62 20l9 11 2 3 5 10 3 7c8 17 8 37 8 56v2c0 31-4 60-20 87-3 5-4 8-4 14v6a40387 40387 0 0 1-1 28v3c-1 11-1 24-10 33-7 6-14 6-23 6h-3a1156 1156 0 0 1-21 1h-3c-8 0-14-3-20-8-6-8-7-18-8-28v-3a1710 1710 0 0 1-2-24c1-10 1-10-2-18h-13a4698 4698 0 0 0-35 0h-55a374 374 0 0 0-1 38c-1 29-1 29-9 37-7 5-13 5-22 5h-3a891 891 0 0 1-21 0h-3c-7 0-13-1-19-5-9-10-9-24-10-37a8574 8574 0 0 0-2-29v-4c0-6 0-6-3-11l-3-2-2-2-2-1a83 83 0 0 1-29-65l1-38h1v3a3006 3006 0 0 0 1 46v2l5 17 1 2c4 12 12 22 21 30l2 2c8 8 18 11 29 11h5l11-1c6 6 3 30 4 39 0 18 0 18 6 35l-1 4-1-3h-2l-2-4-2-3c-2-6-2-13-2-20a7350 7350 0 0 0 0-12c-1-11-1-21-4-31h-13c-7-1-13-2-19-5 0 14 0 14 2 27 2 12 2 25 2 37h2l1 3c2 5 5 9 10 11l14 1h3a1275 1275 0 0 0 22 1h3c7 0 11-2 17-6l3-2c4-4 3-11 3-16v-8l1-12v-22l1-2c0-4 0-8 2-11l6-1h9a4372 4372 0 0 1 82 0h3l13 1h10a2051 2051 0 0 0 22 0l2 29 1 3v11c0 12 1 21 6 31l2 5h12c7-1 12-3 17-7 3-3 4-8 6-12h2v-2a4011 4011 0 0 1 1-50c0-7 1-12 5-18l1-3 5-8c9-15 11-30 13-47v-2l1-25v-8c0-14-1-29-4-43h-2a228572524 228572524 0 0 1-10-22c-3-12-15-20-25-26-14-8-28-9-44-9a1067 1067 0 0 1-73 1h-10c-7 0-7 0-11-3-6-8-7-14-7-23v-11l1-61v-15l1-30-11 6a136 136 0 0 1-35 15l-7 1v-2l-19 3-14 1v-1l12-3-38 2 4 2c-16 1-30-2-44-7l-3-1-9-7 4 1c-1-4-3-6-7-9l-5-5v-6l4 1v-8a256084569 256084569 0 0 0 12 6l2 1c6 2 6 2 7 6l1 5h3l1 2c2 3 5 3 9 4 34 6 72 0 102-16l-1-2-3-1-7-4-6-3h-2c-5 1-6 1-10-2-3-2-4-4-5-7 0-7 0-11 5-16 4-4 9-5 14-4 4 0 6 1 9 4 2 3 2 6 2 10v2l4 2 2 1v2h2v3l6 2 4 1c3 1 3 1 6-1l3-2 3-1v-11l-1-4v-4a2837 2837 0 0 1-3-10v-7h-3c-6 0-6 0-9-2-4-5-5-10-5-16v-7l3-2v12h4v-2c1-7 3-14 7-20l-4-2 1-2h3l-1-6-1-3-2-4v11h-2v-2c-1-8-3-15-7-22l-2-5c-3-10-17-18-26-23l-2-2c-8-4-18-6-26-7l-7-2c-23 2-42 15-57 32-3 3-4 7-5 11h4l28 4 3 1c6 1 11 3 16 6l3 1 17 11v2l2 1c7 4 9 12 11 20l1 20-1-4h-2v3c0 10-4 20-9 28v-6c5-14 4-31-2-44l-2-5c-1-3-2-3-5-4l-1-3h-2l-7-3a67 67 0 0 0-17-8c-14-5-29-7-44-8-7-1-7-1-9-3l-1-2h-2v3l-16 3 3-6 6-1 6-4 3-6c4-7 9-12 15-17l4-4c7-7 19-14 29-15l3-1 1-2c2-4 3-4 7-5 20-4 40-1 58 7Z"
    />
    <path
      fill="#FAFAFA"
      d="m294 76 9 2c19 3 35 14 48 28l2 5 3 7c4 7 5 13 5 21h2l-1-13c4 4 5 7 5 12v3h-3l1 3 2 1-1 2-1 3-1 2-4 15h-4l-1-11c-2 2-1 5-1 8v3c0 4 1 7 3 10l1 3 12 2a1574 1574 0 0 1 5 24l1 4c0 3 0 5-2 8-3 3-5 5-9 6l-9-3-2-1-2-1v-3h-2v-2l-2-1-4-2-1-5c0-3-1-6-3-8-5-3-9-3-14-2-5 2-7 4-10 8-2 5-2 9 0 14 4 4 7 5 12 6l4-1 4 1 2 2c3 3 6 5 10 6v3c-19 9-38 15-59 17h-3c-13 2-37 4-49-4-3-3-3-7-3-11h3a89 89 0 0 0 55-7v-2l4-3a58 58 0 0 0 17-40v-3c0-13-2-27-11-37a85 85 0 0 0-43-21l-3-1-19-2-8-2c1-11 13-21 21-28 10-8 30-20 44-15Z"
    />
    <path
      fill="#FBFBFB"
      d="m255 137 3 1c16 4 33 11 41 25 6 12 6 27 2 39s-11 20-22 25c-18 7-40 5-57-3-15-7-22-23-28-38-3-15-1-29 5-43 1 4 0 6-1 10l-3 12h2l1-6h1v20l-2-1v-5h-2c2 16 9 34 22 45l5 2 2 1 3 1 3 1 11 2h2a953 953 0 0 0 6-1c1-5 2-9 5-13v-2c1-4 3-6 5-8h2v-2l-7-1v3c-4 0-6-1-9-4l-1-1 1 5h-2l-1-2-1 2c-2-3-2-5-2-9l1-2v-2h-3c-13 0-13 0-19-5-2-2-2-4-2-7l3 3v2l8 1h5l3-1h6v-2l-2 1h-9c-5 0-7 0-10-3h7l-3-1-6-4 2-6-2-1c4-2 5-2 10-2l3 1h3v-2l-12-2c3-6 6-9 12-11l6-2 2-1 9-1-4-6-12-2-3-1h-12l-3-1h-12v2c-7 0-7 0-10-2v-2c17-7 42 0 60 4Z"
    />
    <path
      fill="#101010"
      d="M379 297h1a211830099 211830099 0 0 1 0 51c-1 16-1 16 4 30v2c5 3 10 2 15 2h4a1865 1865 0 0 0 74 1c24 0 44 2 62 20l9 11 2 3 5 10 3 7c8 17 8 37 8 56v2c0 31-4 60-20 87-3 5-4 8-4 14v6a40387 40387 0 0 1-1 28v3c-1 11-1 24-10 33-7 6-14 6-23 6h-3a1156 1156 0 0 1-21 1h-3c-8 0-14-3-20-8-6-8-7-18-8-28v-3a1710 1710 0 0 1-2-24c1-10 1-10-2-18h-13a4698 4698 0 0 0-35 0h-55a374 374 0 0 0-1 38c-1 29-1 29-9 37-7 5-13 5-22 5h-3a891 891 0 0 1-21 0h-3c-7 0-13-1-19-5-9-10-9-24-10-37a8574 8574 0 0 0-2-29v-4c0-6 0-6-3-11l-3-2-2-2-2-1a83 83 0 0 1-29-62v-3l1-38h1v3a3006 3006 0 0 0 1 46v2l5 17 1 2c4 12 12 22 21 30l2 2c8 8 18 11 29 11h5l11-1c6 6 3 30 4 39 0 18 0 18 6 35l-1 4-1-3h-2l-2-4-2-3c-2-6-2-13-2-20a7350 7350 0 0 0 0-12c-1-11-1-21-4-31h-13c-7-1-13-2-19-5 0 14 0 14 2 27 2 12 2 25 2 37h2l1 3c2 5 5 9 10 11l14 1h3a1275 1275 0 0 0 22 1h3c7 0 11-2 17-6l3-2c4-4 3-11 3-16v-8l1-12v-22l1-2c0-4 0-8 2-11l6-1h9a4372 4372 0 0 1 82 0h3l13 1h10a2051 2051 0 0 0 22 0l2 29 1 3v11c0 12 1 21 6 31l2 5h12c7-1 12-3 17-7 3-3 4-8 6-12h2v-2a4011 4011 0 0 1 1-50c0-7 1-12 5-18l1-3 5-8c9-15 11-30 13-47v-2l1-25v-8c0-14-1-29-4-43h-2l-1-2c-1-4-3-8-6-11l-3-9c-3-12-15-20-25-26-14-8-28-9-44-9a1067 1067 0 0 1-73 1h-10c-7 0-7 0-11-3l-2-3-1-2c-3-4-4-8-3-13v-2a607 607 0 0 1 0-13l1-53Z"
    />
    <path
      fill="#F9F9F9"
      d="m258 587 8 2 7 1 3 1h14c3 8 4 16 4 24a8548 8548 0 0 0 1 22v3c0 6 1 11 3 16l2 6h2l1 2 2-1v2l20 1v1a3217 3217 0 0 1-36 0h-3c-7 0-12 0-17-5l-2-2-2-3-1-6h-2a52 52 0 0 1-1-13v-3l-2-21-1-27ZM453 590a748956074 748956074 0 0 0 24 1h7c4 8 4 16 4 25v29l3 9 1 2 5 7 1 4h-13l-4 1c-7 0-11-1-16-5-5-5-7-10-9-17l-1-2-1-10v-2a2162 2162 0 0 1-1-42Z"
    />
    <path
      fill="#F0F0F0"
      d="m283 74-3 1a98 98 0 0 0-37 20c-6 6-11 11-15 19v6l18 3c17 3 32 7 46 16l2 1c9 6 15 14 17 25 2 17 0 33-9 47v-6c5-14 4-31-2-44l-2-5c-1-3-2-3-5-4l-1-3h-2l-7-3a67 67 0 0 0-17-8c-14-5-29-7-44-8-7-1-7-1-9-3l-1-2h-2v3l-16 3 3-6 6-1 6-4 3-6c4-7 9-12 15-17l4-4c8-8 20-14 32-16l4-2 7-2 3-1 6 1Z"
    />
    <path
      fill="#363636"
      d="m207 233 2 2c10 10 22 14 36 17l5 3c3 2 5 1 8 0h9a16536 16536 0 0 0 21 0h2c4 0 6 0 9-2l7-1 28-7 14-4c-6 6-16 8-24 11 10-3 20-6 30-11 6-2 11-4 17-4-4 4-7 7-13 9l-2 1c-14 6-29 11-44 14l-2 1-27 2a5950 5950 0 0 0-16 1l4 2c-16 1-30-2-44-7l-3-1-9-7 4 1c-1-4-3-6-7-9l-5-5v-6Z"
    />
    <path
      fill="#0E0E0E"
      d="M218 475h1v3a3006 3006 0 0 0 1 46v2l5 17 1 2a81 81 0 0 0 23 32c8 8 18 11 29 11h5l11-1c6 6 3 30 4 39 0 18 0 18 6 35l-1 4-1-3h-2l-2-4-2-3c-2-6-2-13-2-20a7350 7350 0 0 0 0-12c-1-11-1-21-4-31h-13c-7-1-13-2-19-5 0 14 0 14 2 27 2 12 2 25 2 37h2l1 3c2 5 5 9 10 11l14 1h3a1275 1275 0 0 0 22 1h3c7 0 11-2 17-6l3-2c4-4 3-11 3-16v-3a2430 2430 0 0 0 1-17v-3l1-27h1v55c-1 7-2 11-7 16-7 5-13 5-22 5h-3a891 891 0 0 1-21 0h-3c-7 0-13-1-19-5-9-10-9-24-10-37a8574 8574 0 0 0-2-29v-4c0-6 0-6-3-11l-3-2-2-2-2-1a83 83 0 0 1-29-62v-3l1-38Z"
    />
    <path
      fill="#EBEBEB"
      d="M371 237c-4 4-7 7-13 9l-2 1c-14 6-29 11-44 14l-2 1-23 2h-3c-19 0-38 0-55-8h9c24 6 50 5 73 0l-3 1h-13c3-4 6-5 11-5l28-7 14-4c-6 6-16 8-24 11 10-3 20-6 30-11 6-2 11-4 17-4Z"
    />
    <path
      fill="#151515"
      d="m211 226 2 1a228 228 0 0 0 10 5l2 1c6 2 6 2 7 6l1 5h3l1 2c2 3 5 3 9 4 24 4 48 2 71-4l3-1 2-1 6 1c-5 6-16 7-24 8-3 0-5 1-8 3a113 113 0 0 1-11 0 1382 1382 0 0 1-30 1c-4 0-5-1-8-3s-6-2-10-3c-11-2-20-7-28-15l1-2h1v-8Z"
    />
    <path
      fill="#232323"
      d="m212 125 2 1 1 3h2c24 2 50 5 70 19l5 2c9 8 14 19 14 32 0 12-1 27-8 38l-4 2-2 2v-8l2-3c9-11 9-25 8-39l-4-11-1-3-3-3-2-1v-2l-2-1-6-4c-24-14-61-21-89-16l1-2 7-1 4-1h3v-3l2-1Z"
    />
    <path
      fill="#101010"
      d="M350 587h9a4372 4372 0 0 1 82 0h3l13 1h10l3 1h13v1l-11 1h-3l-3 1h-3l-10-2a15875 15875 0 0 0 2 40v4l1 3v3l1 6v7c-2-3-3-6-3-10v-2l-2-30c0-12 0-12-3-22h-13a4698 4698 0 0 0-35 0h-55a400 400 0 0 0-2 47v2l-1 14h-1a1130 1130 0 0 1 1-52v-2l1-10 6-1Z"
    />
    <path
      fill="#EAEAEA"
      d="M379 160c9 5 14 14 17 23l1 13v3c0 8-2 14-6 21l-2 2-1 2h-2v2l-4 3-2 1c-7 4-13 4-21 3l-8-4-2-2-2-1 1-3 2 1c10 3 19 5 29 0l5-4h2l1-2 4-9c4-10 3-23-1-32-2-6-5-9-10-13l-1-1v-3Z"
    />
    <path
      fill="#E1E1E1"
      d="M330 155c3 2 6 4 7 8l-1 10c-3 3-4 4-8 5-5 0-7 0-11-3-2-4-3-7-3-12 1-3 3-5 6-7 4-2 6-2 10-1Z"
    />
    <path
      fill="#0F0F0F"
      d="M379 297h1a211830099 211830099 0 0 1 0 51c-1 16-1 16 4 30v2c5 3 10 2 16 2h3a1857 1857 0 0 0 85 1h3l18 2v1a12065 12065 0 0 1-114 0c-7 0-7 0-11-3l-2-3-1-2c-3-4-4-8-3-13v-2a607 607 0 0 1 0-13l1-53Z"
    />
    <path
      fill="#E9E9E9"
      d="m207 233 2 2c10 10 22 14 36 17l5 3c3 2 5 1 8 0h26l10 2v1l-21 1h-2c-21 0-47-2-63-18l-1-8Z"
    />
    <path
      fill="#0A0A0A"
      d="M327 113c3 1 4 2 6 5 2 5 1 10-1 15-3 2-4 2-8 2h-4l2-2-2-1c-4-2-5-3-6-7 0-4 1-7 4-10s5-2 9-2Z"
    />
    <path
      fill="#2A2A2A"
      d="m379 234 2 1c-1 3-3 3-6 5l-5 3c-18 11-37 18-58 22l-3 1-16 1v-1l12-3v-2h3c21-4 42-11 61-22v-3h3c4 0 4 0 7-2Z"
    />
    <path
      fill="#3E3E3E"
      d="M342 593h1v55c-1 7-2 11-7 16-7 5-13 5-22 5h-3a891 891 0 0 1-21 0h-3c-8 0-15-1-21-7l1-2 1 1 2 1 2 2c3 2 7 2 11 2h2a2394 2394 0 0 0 32 1c7 0 11-2 17-6l3-2c4-4 3-11 3-16v-3a2430 2430 0 0 0 1-17v-3l1-27Z"
    />
    <path
      fill="#D7D7D7"
      d="m225 153 2 1-5 6h7l5 2v2h-14l-1 5-1 3 12 5v1h-8c3 2 7 1 11 1h8v2c-14 3-14 3-20 1l-4-4-2 1v-4l-3-1c0-6 0-6 3-9l3-3c3-1 3-3 4-6l3-3Z"
    />
    <path
      fill="#DEDEDE"
      d="M258 139h-2v2l-7 1-2-3-6-1-3-1h-3l-3-1h-12l-3-1h-12v2c-7 0-7 0-10-2v-2c15-6 49-3 63 6Z"
    />
    <path
      fill="#656565"
      d="m225 225 3 1 5 1h2c13 4 25 4 38 1h6v3l-5 1-2 1-3 1-2 1c-13 2-30 0-41-6l-1-4Z"
    />
    <path
      fill="#F0F0F0"
      d="m211 226 2 1a228 228 0 0 0 10 5l2 1c6 2 6 2 7 6l1 6c-9-1-16-5-22-11v-8Z"
    />
    <path
      fill="#797979"
      d="M199 143c1 4 0 6-1 10l-3 12h2l1-6h1v20l-2-1v-5h-2c2 15 7 26 16 38l-2 4-1-2-1-2-1-2-4-6c-9-14-11-29-8-45l5-15Z"
    />
    <path
      fill="#DBDBDB"
      d="M348 242c-7 4-17 10-26 10v2c-8 3-18 3-27 3 3-4 6-5 11-5l20-5 3-1 15-5 4 1Z"
    />
    <path
      fill="#363636"
      d="M330 155c3 2 6 4 7 8l-1 10c-3 3-4 4-8 5-5 0-7 0-11-3-2-4-3-7-3-12 1-3 3-5 6-7 4-2 6-2 10-1Zm-13 6 1 3-1 7c4 2 8 3 13 2l5-2v-9c-3-4-5-5-10-6l-8 5Z"
    />
    <path
      fill="#4C4C4C"
      d="M218 475h1v3a3006 3006 0 0 0 1 46v2l5 17 1 2c4 12 12 22 21 30-5 0-7-3-10-6-8-8-12-19-16-29l-1-2c-6-19-4-43-2-63Z"
    />
    <path
      fill="#2B2B2B"
      d="m362 142 5 3-1 2-1 3-1 2-4 15h-4l-1-11-2 1c2-6 4-11 9-15Z"
    />
    <path
      fill="#CACACA"
      d="m371 240 2 1c-19 12-39 20-61 24l-3 1-16 1v-1l18-4c20-3 40-10 58-21l2-1Z"
    />
    <path
      fill="#181818"
      d="M243 128c7 0 13 0 20 3h3c14 5 29 11 37 23v3c-3-1-5-1-7-4-3-4-5-5-9-7l-4-4c-8-10-29-11-40-13v-1Z"
    />
    <path
      fill="#242424"
      d="m272 147 1 3 4 2c3 0 5 1 8 3v2h-4l-1 4h-9v-3l-4 1-1-4 2-1 3-4h-2v-2l3-1Z"
    />
    <path
      fill="#A6A6A6"
      d="M330 111c3 2 5 4 6 7v2h-3l-1-2c-1-2-2-3-5-4-4 0-6-1-9 2-2 2-3 4-3 7 1 4 1 5 4 8l3 1 3 2h-10c-3-4-4-7-4-12 1-5 3-7 7-11h12Z"
    />
    <path
      fill="#2B2B2B"
      d="m212 125 2 1 1 3h2c13 1 27 2 40 6-4 2-4 2-9 1h-3l-3-1c-23-4-23-4-47-2l1-2 7-1 4-1h3v-3l2-1Z"
    />
    <path
      fill="#272727"
      d="M505 386c9-1 17 3 24 8 7 6 15 12 19 20v6h2v6l-2-1-1-5c-3-12-15-20-25-26l-17-7v-1Z"
    />
    <path
      fill="#B6B6B6"
      d="m334 197 7 6 1 6-2-2-5-5-8 2c-3 3-3 7-3 11h-3c-2-4-3-7-2-11 4-6 8-8 15-7Z"
    />
    <path
      fill="#F0F0F0"
      d="M270 255h14l10 2v1l-13 1h-2a1920 1920 0 0 1-22 0l-1-3c4-2 10-1 14-1Z"
    />
    <path
      fill="#171717"
      d="M304 192h1c0 9-1 20-7 28l-4 2-2 2v-8l2-2c4-6 6-11 8-18l2-4Z"
    />
    <path
      fill="#0E0E0E"
      d="m264 75 1 3-3 1c-11 2-21 7-29 14l-3 1-1 3-1-3c8-9 23-20 36-19Z"
    />
    <path
      fill="#9B9B9B"
      d="m240 87 2 1-2 3v2l-4 3-7 8-2 3h-2l-1 4h-2l1-2 1-5-7 6c3-10 14-17 23-23Z"
    />
    <path
      fill="#161616"
      d="m209 234 11 6c5 3 10 4 16 4l2 5c-7 2-12-1-18-4-5-3-9-6-11-11Z"
    />
    <path
      fill="#9F9F9F"
      d="M223 406h1a546 546 0 0 1-4 68h-1a411 411 0 0 1 4-68Z"
    />
    <path
      fill="#777"
      d="m378 164 7 5 2 3h2c4 7 4 11 3 19l-3-7c-2-6-3-11-8-15v3c-3 3-4 3-8 3h-3l-1-2h8v-2l-4-1 1-3h6l-2-3Z"
    />
    <path
      fill="#ACACAC"
      d="m258 587 3 1h-2a1409 1409 0 0 0 1 10l1 4 1 12v3l1 34h-1a52 52 0 0 1-1-13v-3l-2-21-1-27Z"
    />
    <path
      fill="#E5E5E5"
      d="M385 146c3 3 3 5 3 9h-2l-2-7h-3l2 3h-12c-4 4-5 10-5 16h-2c0-7 0-13 5-19 6-4 10-5 16-2Z"
    />
    <path fill="#A5A5A5" d="M232 288h1v10l-1 13v12l-3 21-1 18h-1l2-45 3-29Z" />
    <path
      fill="#CFCFCF"
      d="m215 252 8 3c12 5 25 8 38 9 4 1 7 1 10 3-16 1-30-2-44-7l-3-1-9-7Z"
    />
    <path
      fill="#939393"
      d="M369 193h3a827 827 0 0 1 3 12c2 9 2 9-1 13l-4-1-1-24Z"
    />
    <path
      fill="#202020"
      d="M298 143c5 1 7 4 10 8 6 10 6 22 6 34l-1-4h-2v-3c-1-13-3-23-12-33l-1-2Z"
    />
    <path fill="#F0F0F0" d="M381 189h8v14c-5-1-5-1-7-3l-1-6v-5Z" />
    <path
      fill="#2B2B2B"
      d="M538 615h1c2 36 2 36-8 48l-1 1-4-1 2-2c4-3 5-8 7-13h2l1-33Z"
    />
    <path fill="#1D1D1D" d="M233 268h1l-4 55h-1l1-41 1-4 2-10Z" />
    <path
      fill="#252525"
      d="m236 249 10 1 9 1h2l6 1v1l10 1v1h-7l-2 1-9 1c-4 0-5-1-8-3s-7-2-11-3v-2Z"
    />
    <path
      fill="#DEDEDE"
      d="m210 213 5 3 12 6 3 1 11 2v1h-5v2c-10-1-19-5-26-12v-3Z"
    />
    <path
      fill="#939393"
      d="M453 590h1v2a6049 6049 0 0 0 1 18l1 3 1 6v27l-3-12v-2a992 992 0 0 1-1-42Z"
    />
    <path
      fill="#D7D7D7"
      d="M379 160c9 5 14 14 17 24l1 9h-1l-1 8h-1v-4c-1-16-1-16-10-30l-5-4v-3Z"
    />
    <path fill="#232323" d="m325 162 7 1-2 8h-7c-2-2-2-2-2-5 0-4 0-4 4-4Z" />
    <path
      fill="#1B1B1B"
      d="M259 616h1a83 83 0 0 1 1 17 31333 31333 0 0 1 1 18h2l1 3 6 9c-5-2-8-5-10-10-2-8-2-17-2-26v-11Z"
    />
    <path
      fill="#606060"
      d="m379 149-2 1-2 2v2l2-1h3l3 3-7 1-2 7h-2l-1-3-2 2 1-9-2-1c4-3 6-5 11-4Z"
    />
    <path
      fill="#888"
      d="m342 213 2 1v2l2 1-2 3 4-3-6 9v-2l-5-2v-2h-2l2-6 5-1Z"
    />
    <path
      fill="#212121"
      d="m367 138 1 3h6c-1 5-3 7-7 11l-2 6-3-2 5-11-4-2 1-2h3v-3Z"
    />
    <path
      fill="#252525"
      d="m230 257 13 2c10 3 20 4 30 4v1c-15 2-29 1-43-6v-1Z"
    />
    <path
      fill="#2D2D2D"
      d="M457 647h1l1 4c1 6 4 10 10 14a3649935258 3649935258 0 0 1 29 2v1h-13l-4 1c-8 0-14-1-20-7-3-3-5-6-5-10l1-5Z"
    />
    <path
      fill="#7D7D7D"
      d="M353 110c6 5 10 12 10 20v9h-2v-2c-1-8-3-15-7-22l-2-3 1-2Z"
    />
    <path
      fill="#7B7B7B"
      d="m317 224 8 2v2l-3 1 3 1v2l8-1-1 2-8 1h-5l-1-3-4-2v-2l5 1-2-4Z"
    />
    <path fill="#8D8D8D" d="m331 238 1 2c-4 4-9 6-15 7l-8-1 1-2 6-1 15-5Z" />
    <path fill="#1C1C1C" d="m346 179 4 2v5l-4 2c-3 0-3 0-5-2v-5c2-2 2-2 5-2Z" />
    <path
      fill="#525252"
      d="M362 205c2 1 4 1 5 4l-1 4c-2 2-2 2-5 2l-3-1 1-7 3-2Z"
    />
    <path
      fill="#1A1A1A"
      d="M326 195c5-1 10-1 14 2 4 4 4 7 4 12v2l-3-5c-1-3-1-3-4-5l-4-1h-4v-1l5-1-8-2v-1Z"
    />
    <path
      fill="#4C4C4C"
      d="M243 128c7 0 13 1 20 3l3 1c7 1 13 4 19 7l-3 2-2-1c-11-7-24-9-37-11v-1Z"
    />
    <path
      fill="#4A4A4A"
      d="M313 117c2 3 2 4 2 7l2 6 8 3v1h-10c-3-4-4-7-4-12l2-5Z"
    />
    <path
      fill="#F8F8F8"
      d="m329 157 2 2h-3v2l-6 2-1 6h-2c-2-2-2-4-2-7 2-5 6-6 12-5Z"
    />
    <path fill="#DEDEDE" d="m323 117 7 2v7l-8 1v-4h-3v-2l3-1 1-3Z" />
    <path
      fill="#1F1F1F"
      d="M234 104h2l-5 9-2 6h5l3 1h2l1 2h-7l-6-2c-1-6 1-9 5-13l2-3Z"
    />
    <path fill="#414141" d="m217 177 3 1 13 1h8v2c-14 3-14 3-20 1l-4-5Z" />
    <path
      fill="#151515"
      d="M315 163h1l2 8 4 1 5 2v2l5-1-1 2c-5 1-8 1-12-1-2-2-4-4-4-7v-6Z"
    />
    <path fill="#C7C7C7" d="M198 159h1v20l-2-1v-5h-3v-8h3l1-6Z" />
    <path
      fill="#1A1A1A"
      d="M528 665c-6 4-12 4-20 4h-9c3-3 7-2 11-2 6-1 13-4 18-2Z"
    />
    <path fill="#CECECE" d="M323 262v1l-10 2-3 1-17 1v-1c22-6 22-6 30-4Z" />
    <path fill="#E9E9E9" d="m364 144 3 1-5 11-5-1c1-5 3-8 7-11Z" />
    <path fill="#232323" d="M482 588h7v10l-3 1-2-7-10-1v-1l8-1v-1Z" />
    <path fill="#070707" d="m452 588 31 1v1l-11 1-3 1c-7 0-11 0-17-3v-1Z" />
    <path fill="#111" d="M311 181h2c0 7 0 14-2 21l-2-2-2 1 1-2 3-18Z" />
    <path
      fill="#E2E2E2"
      d="M330 197h2l4 2h-2c-6 1-6 1-11 5-2 3-3 5-3 8h-1c-1-8-1-8 2-11s5-4 9-4Z"
    />
    <path fill="#DCDCDC" d="M388 160c4 2 9 5 11 9v7l-6-7-2-3-3-6Z" />
    <path
      fill="#171717"
      d="M378 361h2v2c0 6 1 10 4 15v2l3 1 1 3c-3 0-4-1-6-3-4-7-5-12-4-20Z"
    />
    <path
      fill="#3E3E3E"
      d="m379 234 2 1c-2 5-9 6-14 8l-5 3-3-1 2-1 9-6-1-2h3c4 0 4 0 7-2Z"
    />
    <path fill="gray" d="m374 167 8 1c0 3-1 4-3 6l-9 1-1-2h8v-2l-4-1 1-3Z" />
    <path
      fill="#555"
      d="m330 155 3 3-2 1-2-1c-5 0-5 0-9 2l-2 1 1 2v6h-3l-1-8c4-6 9-7 15-6Z"
    />
    <path fill="#828282" d="m292 92 5 1 1 4-3 3-4-1-1-5 2-2Z" />
    <path
      fill="#383838"
      d="m547 570-1 7-1 3-1 2-1 4-1 2h-2v11h-1c0-8 0-14 4-21l2-4 2-4Z"
    />
    <path fill="#E6E6E6" d="M362 126c4 4 5 7 5 12v3l-5 1-1-3h2l-1-13Z" />
    <path fill="#323232" d="m281 131 12 6 2 1 5 5c-8-1-14-6-20-11l1-1Z" />
    <path fill="#010101" d="M226 94h2c-1 4-2 6-5 8l-2 2-2 2-2-2 3-4 2-2 4-4Z" />
    <path
      fill="#151515"
      d="M341 648h1c0 6 0 9-4 14l-1 2c-3 2-6 2-9 2l7-6c3-2 5-4 6-8v-4Z"
    />
    <path fill="#191919" d="M218 523h2v2l5 18 1 5h-2l-3-9-1-2c-2-5-2-9-2-14Z" />
    <path
      fill="#2B2B2B"
      d="M298 143c6 1 8 5 11 10 2 4 2 6 1 10l-3-6c-2-5-5-9-9-14Z"
    />
    <path
      fill="#B7B7B7"
      d="m283 74-8 3-3 1-2 1h-2c-5 2-7 2-12 1v-1h2l2-1h3l4-2 7-2 3-1 6 1Z"
    />
    <path fill="#070707" d="M548 416c5 4 6 9 8 14v3c-3-2-5-4-6-8v-5h-2v-4Z" />
    <path fill="#CACACA" d="m317 167 1 2 12 1 2-3 3 4c-4 2-8 3-13 2l-5-2v-4Z" />
    <path
      fill="#333"
      d="m245 93 2 2-10 10-3-2 4-4 3-3 4-3ZM345 244l-3 4-2 1h-2l-3 1-2 1c-7 2-7 2-11 1l4-1 4-2 3-1h2l2-1 4-2 4-1Z"
    />
    <path fill="#E1E1E1" d="M337 205v2l-3 1c-4 1-4 1-6 4h-2v-5c3-4 6-3 11-2Z" />
    <path
      fill="#CDCDCD"
      d="M385 146c3 3 3 5 3 9h-2l-2-7h-9l-3-2c5-2 8-2 13 0Z"
    />
    <path fill="#999" d="m341 213 2 1-4 8h-2v-2h-2l2-6 4-1Z" />
    <path
      fill="#D4D4D4"
      d="M283 145c4 0 6 0 9 3l2 1 3 4-2 2-3-3v-2h-2c-4-1-5-2-7-5Z"
    />
    <path fill="#DADADA" d="m216 176 3 3v2l10 2-3 1v2l2 1-10-4c-2-3-2-3-2-7Z" />
    <path fill="#313131" d="m247 262 26 1v1l-9 1h-3c-5 0-9 0-14-2v-1Z" />
    <path fill="#242424" d="m337 202-2 3-7 1-2 5-2-3 4-6h9Z" />
    <path fill="#1B1B1B" d="M227 160c4 0 4 0 7 2v2h-7l-5-2c2-2 2-2 5-2Z" />
    <path fill="#F2F2F2" d="m356 157 4 1v9h-4v-10Z" />
    <path
      fill="#343434"
      d="m272 147 1 3 5 1v1l-3 1-5 3 1 2-4 1-1-4 2-1 3-4h-2v-2l3-1Z"
    />
    <path fill="#1E1E1E" d="m336 260-1 3-5 1-2 1h-2l-1-4c7-2 7-2 11-1Z" />
    <path fill="#CACACA" d="M247 137h6l5 2h-2v2l-7 1-2-5Z" />
    <path fill="#C7C7C7" d="m201 125 2 1-2 5-7 1c0-3 1-4 3-6l4-1Z" />
    <path fill="#1D1D1D" d="M254 136c7 0 12 2 18 5-4 1-6 0-10-1l-4-1-4-3Z" />
    <path
      fill="#232323"
      d="M328 245c-2 3-5 4-8 5l-3-1h2v-2l-2-1c7-2 7-2 11-1Z"
    />
    <path fill="#9A9A9A" d="M202 200c4 3 6 7 9 11l-2 4-1-2-1-2-2-3-3-5v-3Z" />
    <path fill="#BCBCBC" d="M305 191h1c1 8 1 13-3 19l-1 2v-6l3-15Z" />
    <path fill="#2B2B2B" d="m276 142 5 2 2 1 2 1-2 3-2-1-2-1-3-2-6-3h6Z" />
    <path
      fill="#424242"
      d="m212 125 1 4c-3 3-6 3-10 3h-2l-6 1 1-2 7-1 4-1h3v-3l2-1Z"
    />
    <path fill="#BABABA" d="M326 110c8 3 8 3 10 7l-1 3h-2l-1-2-3-3-3-3v-2Z" />
    <path fill="#545454" d="m218 248 12 5-2 2c-4 0-7-2-10-4v-3Z" />
    <path fill="#D2D2D2" d="M348 242c-6 4-10 6-18 5l10-4 3-1h5Z" />
    <path fill="#424242" d="M326 195h8c2 0 3 1 5 3h-2v2h-8v-1l5-1-8-2v-1Z" />
    <path fill="#3A3A3A" d="m257 584 15 4v1c-6 2-9 0-14-2v6h-1v-9Z" />
    <path fill="#444" d="m218 167 1 2-1 3 12 5v1c-8 0-8 0-12-3l-1-7 1-1Z" />
    <path fill="#1D1D1D" d="M198 153h2c0 5-1 8-3 12h-2v-5l1-3 2-4Z" />
    <path fill="#848484" d="m317 224 8 2v2c-4 2-7 2-11 1v-2l5 1-2-4Z" />
    <path fill="#BEBEBE" d="m315 218 7 5-5 2-3-4-1-2 2-1Z" />
    <path fill="#D3D3D3" d="M367 151v8l-1 8h-2c0-6 0-10 3-16Z" />
    <path fill="#969696" d="m380 153 3 3-7 1-2 7h-2c0-4 1-6 3-9 2-2 2-2 5-2Z" />
    <path
      fill="#BABABA"
      d="m313 121 3 5c1 4 3 4 6 6l3 2c-6 0-6 0-9-3s-3-6-3-10Z"
    />
    <path fill="#222" d="m254 86 3 1-4 4-3 1-4 2c2-4 4-6 8-8Z" />
    <path fill="#C9C9C9" d="m343 588 1 4-1 1v7l-1 3v10h-1v-20l2-5Z" />
    <path fill="#CDCDCD" d="M379 160c5 3 8 6 11 11l-5-1-1-2-5-5v-3Z" />
    <path fill="#161616" d="m213 126 2 3 6 1h6c-5 3-10 2-16 1l2-5Z" />
    <path fill="#D9D9D9" d="M309 264c-3 3-7 3-12 3h-4v-1c5-2 10-2 16-2Z" />
    <path fill="#161616" d="M309 262c-5 3-10 4-16 4 4-5 10-4 16-4Z" />
    <path fill="#999" d="M287 248h13l-2 3-11-1v-2Z" />
    <path fill="#212121" d="m344 136 2 1-1 3 5-2-2 5-5-1v-5l1-1Z" />
    <path fill="#505050" d="m553 431 5 2 1 7-2 2-4-11Z" />
    <path fill="#DBDBDB" d="M251 137h-16v-1c5-1 11-2 16 1Z" />
    <path fill="#2D2D2D" d="M261 95h2v3h2v-3h2l-1 5-4 1-1-4v-2Z" />
    <path
      fill="#898989"
      d="M558 541c1 4 1 6-1 10l-1 3-1 2c-2-5 0-9 2-13l1-2Z"
    />
    <path fill="#212121" d="m328 197-3 2-9 5 5-7h7Z" />
    <path fill="#434343" d="m354 153 8 3-1 5-1-3-7-1 1-4Z" />
    <path fill="#E1E1E1" d="m263 80-6 4v-2l-7 1 3-3h10Z" />
    <path fill="#F1F1F1" d="M326 197h8l2 2-12 2 2-4Z" />
    <path fill="#EFEFEF" d="M388 182v4h-7l-1-3 8-1Z" />
    <path fill="#0D0D0D" d="m217 105 1 3-5 5c0-4 0-4 2-6l2-2Z" />
    <path fill="#323232" d="M300 655c3 3 4 6 4 10l-2-1v-2h-2v-7Z" />
    <path fill="#3E3E3E" d="m263 651 1 2 4 6 2 2 1 2c-3-2-6-3-8-6v-6Z" />
    <path fill="#343434" d="m289 219 2 1-2 2-4 6h-2v-2l-2-1 3-2 5-4Z" />
    <path fill="#6E6E6E" d="M331 171h2l-1 4-5 1v-2l-4-1h3l5-2Z" />
    <path fill="#505050" d="m336 659 1 4c-3 3-5 3-9 3l8-7Z" />
    <path fill="#131313" d="m342 258-1 3-6 1 1-4h6Z" />
    <path fill="#353535" d="M337 256v1l-5 1-3 1-5-2c5-2 8-2 13-1Z" />
    <path
      fill="#222"
      d="M345 253c-4 2-7 3-11 3 3-4 6-5 11-3ZM298 143c4 1 6 2 8 6l-1 3-3-4-2-2-2-3Z"
    />
    <path fill="#D7D7D7" d="M362 126c3 3 4 4 4 9l-3 3-1-12Z" />
    <path fill="#515151" d="m217 116 4 1-2 4-4-1 2-4Z" />
    <path fill="#191919" d="m296 93 2 1-1 5-5 1-1-3h5v-4Z" />
    <path fill="#D1D1D1" d="m210 213 6 4-1 3-5-4v-3Z" />
    <path fill="#D5D5D5" d="M361 208h4l-1 4h-3l2 2-4-1 2-5Z" />
    <path fill="#6D6D6D" d="m272 158 6 1v3l-7-1 1-3Z" />
    <path fill="#191919" d="M310 194h2l-1 8-2-2-2 1 3-7Z" />
    <path fill="#F0F0F0" d="m345 180 3 1-1 5-3-1 1-5Z" />
    <path fill="#555" d="M241 196c2 2 2 2 2 5h2l-1-5 3 1-1 5h-5v-6Z" />
    <path fill="#E5E5E5" d="m216 176 3 3v2l4 2-4 1c-3-3-3-4-3-8Z" />
    <path fill="#B9B9B9" d="M323 164h5v4l-5-1v-3Z" />
    <path fill="#333" d="M494 659h3l3 7-2 1-4-8Z" />
    <path fill="#1F1F1F" d="m273 229-2 3-8-1v-1l10-1Z" />
    <path fill="#C8C8C8" d="m383 204 4 2-1 4-3-1v-5Z" />
    <path fill="#767676" d="M345 179h3l2 3-2 2-1-3h-2l-2 4-1-5 3-1Z" />
    <path fill="#BEBEBE" d="m331 153 5 2v2l-3 1-3-3 1-2Z" />
    <path fill="#D0D0D0" d="M374 141v2l-6 2-1-3 7-1Z" />
    <path fill="#C2C2C2" d="m344 135 5 1v3l-4 1-1-5Z" />
    <path fill="#424242" d="M457 647h1l2 11-4-4 1-7Z" />
    <path fill="#F3F3F3" d="M328 247h7c-3 3-5 3-9 3l2-3Z" />
    <path fill="#D7D7D7" d="m371 237-4 4-4-3 8-1Z" />
    <path fill="silver" d="M314 163h1l1 10-3 1 1-11Z" />
    <path fill="#FAFAFA" d="M333 164h2v6l-3-1-1-3 2-2Z" />
    <path fill="#8C8C8C" d="m272 147 1 3 5 1v1h-7v-2h-2v-2l3-1Z" />
    <path fill="#151515" d="m284 147 7 3v2l-5-1-2-4Z" />
    <path fill="#E8E8E8" d="m235 91 3 1-6 5 1-5 2-1Z" />
    <path d="m198 230 2 1-2 2v-3Z" />
  </svg>
);
